<template>
  <div class="with-pagination-api">
    <slot />

    <ElPagination
      v-if="showPagination"
      class="el-pagination--block with-pagination-api__pagination"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="sizes, prev, pager, next"
      :total="total"
      @size-change="setPageSize"
      @current-change="setCurrentPage"
    />
  </div>
</template>

<script>
import pagination from '@/mixins/pagination';

export default {
  name: 'WithManualPagination',
  mixins: [pagination],
  props: {
    showPagination: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pageSizes() {
      return this.getPageSizes(this.total);
    },
  },
  methods: {
    setCurrentPage(page) {
      this.$emit('current-change', page);
    },

    setPageSize(size) {
      this.$emit('size-change', size);
    },
  },
};
</script>

<style lang="scss">
.with-pagination-api {
  &__pagination {
    margin-top: $global-margin * 2;
  }
}
</style>
